import React, { useState } from 'react'
import { MenuItem, Button, Badge } from '@material-ui/core'
import { Translate } from 'react-localize-redux'
import PropTypes from 'prop-types'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import useFeatureAccessGuard from 'hooks/useFeatureAccessGuard'
import useTeamFeature from 'hooks/useTeamFeature'
import LockIcon from '@material-ui/icons/Lock'
import { useStyles } from '../styles'
import { IconButton, Menu } from './StyledComponents'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const PhaseMenu = ({ withText, onPhaseSelect }) => {
  const classes = useStyles()

  const phases = ['warmup', 'main_part', 'final_part']

  const [anchorEl, setAnchorEl] = useState(null)

  const featureGuard = useFeatureAccessGuard()

  const { enabled: hasAdvancedTrainingFeaturesEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.advanced_training_features_enabled
  )

  const handleMenuClose = () => setAnchorEl(null)
  const handleMenuOpen = (event) => {
    if (featureGuard(hasAdvancedTrainingFeaturesEnabled)) return

    setAnchorEl(event.currentTarget)
  }

  const handlePhaseSelect = (event) => {
    const { value } = event.currentTarget.dataset
    onPhaseSelect(value)
    setAnchorEl(null)
  }

  return (
    <>
      {withText === true ? (
        <Button
          variant="contained"
          color="primary"
          onClick={handleMenuOpen}
          startIcon={<AddCircleIcon />}
        >
          <Translate id="button.add-activity" />
        </Button>
      ) : (
        <IconButton onClick={handleMenuOpen} size="small">
          <Badge
            className={classes.lockBadgeOnIconButton}
            badgeContent={
              !hasAdvancedTrainingFeaturesEnabled ? (
                <LockIcon color="primary" fontSize="small" />
              ) : null
            }
            overlap="circular"
          >
            <AddCircleIcon />
          </Badge>
        </IconButton>
      )}
      {hasAdvancedTrainingFeaturesEnabled && (
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          PaperProps={{ elevation: 0 }}
        >
          {phases.map((phase) => (
            <MenuItem
              key={phase}
              data-value={phase}
              onClick={handlePhaseSelect}
            >
              <Translate id={`training.${phase}`} />
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  )
}

PhaseMenu.defaultProps = {
  withText: false,
}

PhaseMenu.propTypes = {
  withText: PropTypes.bool,
  onPhaseSelect: PropTypes.func.isRequired,
}

export default PhaseMenu
